<template>
  <div id="app">
    <router-view/>
    <email-verification-dialog/>
  </div>
</template>

<script>
import EmailVerificationDialog from '@/components/common/EmailVerificationDialog.vue'

export default {
  name: 'app',
  components: {EmailVerificationDialog}
}
</script>

<style>
  @font-face {
    font-family: 'latoFont';
    src: url('static/font/Lato-Regular.ttf');
  }
</style>
